(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prime-lux-house"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-plh-root]').forEach((root)=>{if(root.dataset.ready)return;root.dataset.ready='true';const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;const items=root.querySelectorAll('[data-plh-reveal]');if(reduced){items.forEach((el)=>el.classList.add('is-visible'))}else{const io=new IntersectionObserver((entries)=>entries.forEach((entry)=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');io.unobserve(entry.target)}}),{threshold:.08,rootMargin:'0px 0px -8%'});items.forEach((el)=>io.observe(el))}if(!reduced){let active=false;const depth=root.querySelectorAll('[data-plh-depth]');const update=()=>{depth.forEach((el)=>{const r=el.getBoundingClientRect();const p=(innerHeight-r.top)/(innerHeight+r.height);el.style.setProperty('--plh-shift',`${Math.max(-28,Math.min(28,(p-.5)*56))}px`)});active=false};addEventListener('scroll',()=>{if(!active){requestAnimationFrame(update);active=true}},{passive:true});update()}});

  } catch(e) { console.error(e); }
})();
})();
